<iframe style="width:100%; height:100%;" *ngIf="CheckoutURI" allowfullscreen frameborder="0"
    [src]="CheckoutURI | parser: 'resourceUrl'"></iframe>